import {AskAiAgent} from './askAiAgents';

const ASK_AI_PANEL_STORAGE_KEY = 'askAiPanel';

export interface StoredPanel {
  open: boolean;
  agent: AskAiAgent;
  user: string;
}

const CLOSED_PANEL: StoredPanel = {open: false, agent: 'vision', user: ''};

export function readStoredPanel(): StoredPanel {
  try {
    const stored = sessionStorage.getItem(ASK_AI_PANEL_STORAGE_KEY);
    if (!stored) {
      return CLOSED_PANEL;
    }
    const parsed = JSON.parse(stored) as Partial<StoredPanel>;
    return {
      open: parsed.open === true,
      agent: parsed.agent === 'quality' ? 'quality' : 'vision',
      user: typeof parsed.user === 'string' ? parsed.user : '',
    };
  } catch {
    return CLOSED_PANEL;
  }
}

export function storePanel(panel: StoredPanel): void {
  try {
    sessionStorage.setItem(ASK_AI_PANEL_STORAGE_KEY, JSON.stringify(panel));
  } catch {
    return;
  }
}

export function clearStoredPanel(): void {
  try {
    sessionStorage.removeItem(ASK_AI_PANEL_STORAGE_KEY);
  } catch {
    return;
  }
}
